import { injectReducer } from 'store/reducers.js'

export function LoginRoute (store) {
  return {
    path: 'login',

    getComponent (nextState, cb) {
      require.ensure([], (require) => {
        const Container = require('./containers/LoginContainer').default
        const reducer = require('./modules/auth').default
        injectReducer(store, { key: 'auth', reducer })
        cb(null, Container)
      }, 'login')
    }
  }
}

export function LogoutRoute (store) {
  return {
    path: 'logout',
    // WARNING: No actual component / view, this is a fake route and it redirects!
    getComponent (nextState, cb) {
      require.ensure([], (require) => {
        const reducer = require('./modules/auth').default
        const actions = require('./modules/auth').actions

        injectReducer(store, { key: 'auth', reducer })

        store.dispatch(actions.logout())
      }, 'logout')
    }
  }
}

export default function (store) {
  return [
    LoginRoute(store),
    LogoutRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Auth/index.js